<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement" v-if="props.ids == 8">
				<img src="@/assets/Vector@2x (11).png" style="width: 13px; height: 16px" />
				<div class="cement">企业资质</div>
			</div>
			<div class="flex-cement" v-if="props.ids == 4">
				<img src="@/assets/contact_slices/Group 1163@2x1.png" style="width: 13px; height: 16px" />
				<div class="cement">注册协议</div>
			</div>
			<div class="flex-cement" v-if="props.ids == 5">
				<img src="@/assets/contact_slices/Group 1164@2x12.png" style="width: 13px; height: 16px" />
				<div class="cement">隐私政策</div>
			</div>
			<div class="border-top"></div>
			<div v-show="props.ids == 8" style="display: flex; align-items: center">
				<img :src="props.dataImage" style="width: 96%; margin: auto; height: auto" />
			</div>
			<div v-show="props.ids == 4">
				<img v-for="item in dataList" :src="'https://mobile.jingkashou.com/api/admin-api/infra/file/24/get/' + item" style="width: 100%; height: auto" />
			</div>
			<div v-show="props.ids == 5">
				<img v-for="item in dataListObj" :src="'https://mobile.jingkashou.com/api/admin-api/infra/file/24/get/' + item" style="width: 100%; height: auto" />
			</div>
		</div>
	</div>
</template>

<script setup>
let props = defineProps(['ids', 'dataImage', 'dataList', 'dataListObj']);
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
	padding-: 26px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
